import Cupon from "../../components/cupones/Cupon";

const Cupones = ({
  filter,
  setFilter,
  fetch,
  data,
  setData,
  onClick,
  onChange,
  navigate,
  user,
}) => {
  return (
    <div className="min-vh-100">
      <div className="px-3">
        <div
          className="d-flex justify-content-between"
          style={{
            marginRight: "120px",
            marginLeft: "120px",
          }}
        >
          <h2 className="me-2">CUPONES</h2>
          <label
            className="btn btn-custom-naranja fw-normal GothamBold text-white px-4 d-flex align-items-center"
            style={{ borderRadius: "10px", height: "45px" }}
          >
            <i className="bi bi-plus me-2"></i>
            NUEVO CUPON
            <button
              className="d-none"
              name="añadir-cupon"
              onClick={(event) => onClick(event)}
            ></button>
          </label>
        </div>
        <div className="row">
          <div className="col-md-12"></div>

          <div className="col-md-12">
            <div
              className="d-none d-md-flex flex-column flex-sm-row justify-content-between align-items-center my-4"
              style={{
                marginLeft: "120px",
                marginRight: "120px",
              }}
            >
              <div className="mb-2 mb-sm-0">
                <small className="text-muted">
                  Mostrando{" "}
                  <span className="fw-medium">CUPONES {data?.total}</span>
                </small>
              </div>

              <div>
                {data.links.map((link) => {
                  if (link.label == "&laquo; Previous") {
                    return (
                      <label
                        className={`btn btn-outline-dark me-1 ${
                          link.active ? "active" : ""
                        } ${link.url ? "" : "disabled"}`}
                      >
                        <i class="bi bi-chevron-left"></i>
                        ANTERIOR
                      </label>
                    );
                  }
                  if (link.label == "Next &raquo;") {
                    return (
                      <label
                        className={`btn btn-outline-dark ${
                          link.active ? "active" : ""
                        } ${link.url ? "" : "disabled"}`}
                      >
                        SIGUIENTE
                        <i class="bi bi-chevron-right"></i>
                      </label>
                    );
                  }
                  return (
                    <label
                      className={`btn btn-outline-dark me-1 ${
                        link.active ? "active" : ""
                      }`}
                    >
                      {link.label}
                    </label>
                  );
                })}
              </div>
            </div>

            <div className="tab-content" id="eventosTabContent">
              <div className="tab-pane fade" id="anteriores" role="tabpanel">
                <div className="card">
                  <div className="card-body text-center py-5">
                    <p className="text-muted">
                      No hay eventos anteriores para mostrar.
                    </p>
                  </div>
                </div>
              </div>

              <div
                className="tab-pane fade show active"
                id="proximos"
                role="tabpanel"
              >
                <div
                  className="card d-none d-lg-block"
                  style={{
                    marginLeft: "120px",
                    marginRight: "120px",
                  }}
                >
                  <div className="table-responsive">
                    <table className="table table-hover mb-0">
                      <thead className="table-light">
                        <tr>
                          <th>#ID</th>
                          <th>NOMBRE</th>
                          <th>CODIGO</th>
                          <th>DESCUENTO</th>
                          <th>LIMITE</th>
                          <th>HABILITACIÓN</th>
                          <th>EXPIRA</th>
                          <th>TIPO</th>
                          <th>ESTADO</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {data.data.map((cupon) => {
                          return (
                            <tr>
                              <td className="fw-semibold">#{cupon.id}</td>
                              <td>{cupon.nombre}</td>
                              <td>
                                <div className="fw-semibold ">
                                  {cupon.codigo}
                                </div>
                              </td>
                              <td>
                                <div className="fw-semibold ">
                                  {cupon.descuento}
                                </div>
                              </td>
                              <td>
                                <div className="fw-semibold ">
                                  {cupon.limite}
                                </div>
                              </td>
                              <td>
                                <div className="fw-semibold ">
                                  {cupon.fecha_habilitacion}
                                </div>
                              </td>
                              <td>
                                <div className="fw-semibold ">
                                  {cupon.fecha_expiracion}
                                </div>
                              </td>
                              <td>
                                <div className="fw-semibold">
                                  {cupon.tipo_aplicacion}
                                </div>
                              </td>
                              <td>
                                <div className="dropdown">
                                  <button
                                    className="btn text-dark border fw-normal GothamBold px-3 py-2 fs-10 dropdown-toggle"
                                    style={{ borderRadius: "10px" }}
                                    type="button"
                                    id="dropdownMenuButton1"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                  >
                                    {cupon.status}
                                  </button>
                                  <ul
                                    className="dropdown-menu"
                                    aria-labelledby="dropdownMenuButton1"
                                  >
                                    <li>
                                      <label className="btn m-0 p-0">
                                        <i className="text-success mx-1 bi bi-check-circle-fill"></i>
                                        Activar
                                        <button
                                          className="d-none"
                                          name="status-cupon"
                                          onClick={(event) =>
                                            onClick(event, {
                                              cupon: cupon,
                                              status: "ACTIVO",
                                            })
                                          }
                                        ></button>
                                      </label>
                                    </li>
                                    <li>
                                      <label className="btn m-0 p-0">
                                        <i className="text-secondary mx-1 bi bi-slash-circle-fill"></i>
                                        Pausar
                                        <button
                                          className="d-none"
                                          name="status-cupon"
                                          onClick={(event) =>
                                            onClick(event, {
                                              cupon: cupon,
                                              status: "INACTIVO",
                                            })
                                          }
                                        ></button>
                                      </label>
                                    </li>
                                    <li>
                                      <label className="btn m-0 p-0">
                                        <i className="text-danger mx-1 bi bi-trash"></i>
                                        Eliminar
                                        <button
                                          className="d-none"
                                          name="status-cupon"
                                          onClick={(event) =>
                                            onClick(event, {
                                              cupon: cupon,
                                              status: "ELIMINADO",
                                            })
                                          }
                                        ></button>
                                      </label>
                                    </li>
                                  </ul>
                                </div>
                              </td>
                              <td>
                                <label className={`btn btn-sm btn-outline-dark me-1`}>
                                  <i class="bi bi-pencil-square"></i>
                                  <button
                                    className="d-none"
                                    name="editar-cupon"
                                    onClick={(e) => onClick(e, cupon.id)}
                                  ></button>
                                </label>
                                <label className={`btn btn-sm btn-outline-dark`}>
                                  <i class="bi bi-download"></i>
                                  <button
                                    className="d-none"
                                    name="download-usos"
                                    onClick={(e) => onClick(e, cupon.id)}
                                  ></button>
                                </label>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="d-lg-none">
                  <div className="card mb-3">
                    {data.data.map((cupon) => {
                      return (
                        <div className="row g-0 mb-3">
                          <div className="col-4"></div>
                          <div className="col-8">
                            <div className="card-body p-3">
                              <div className="d-flex justify-content-between align-items-start mb-2">
                                <div className="flex-grow-1">
                                  <h6 className="card-title mb-1 lh-sm">
                                    {cupon.nombre}
                                  </h6>
                                  <small className="text-muted">
                                    #{cupon.id}
                                  </small>
                                </div>
                                <div class="dropdown">
                                  <button
                                    class="btn text-dark border fw-normal GothamBold px-3 py-2 fs-10 dropdown-toggle"
                                    style={{ borderRadius: "10px" }}
                                    type="button"
                                    id="dropdownMenuButton1"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                  >
                                    {cupon.status}
                                  </button>
                                  <ul
                                    class="dropdown-menu"
                                    aria-labelledby="dropdownMenuButton1"
                                  >
                                    <li>
                                      <label className="btn m-0 p-0">
                                        <i class="text-success mx-1 bi bi-check-circle-fill"></i>
                                        Activar
                                        <button
                                          className="d-none"
                                          name="status-cupon"
                                          onClick={(event) =>
                                            onClick(event, {
                                              cupon: cupon,
                                              status: "ACTIVO",
                                            })
                                          }
                                        ></button>
                                      </label>
                                    </li>
                                    <li>
                                      <label className="btn m-0 p-0">
                                        <i class="text-secondary mx-1 bi bi-slash-circle-fill"></i>
                                        Pausar
                                        <button
                                          className="d-none"
                                          name="status-cupon"
                                          onClick={(event) =>
                                            onClick(event, {
                                              cupon: cupon,
                                              status: "INACTIVO",
                                            })
                                          }
                                        ></button>
                                      </label>
                                    </li>

                                    <li>
                                      <label className="btn m-0 p-0 d-none">
                                        <i class="text-danger mx-1 bi bi-trash"></i>
                                        Eliminar
                                        <button
                                          className="d-none"
                                          name="status-cupon"
                                          onClick={(event) =>
                                            onClick(event, {
                                              cupon: cupon,
                                              status: "ELIMINADO",
                                            })
                                          }
                                        ></button>
                                      </label>
                                    </li>
                                  </ul>
                                </div>
                              </div>

                              <div className="row g-2 mb-2">
                                <div className="col-6">
                                  <small className="text-muted">
                                    Ingresos:
                                  </small>
                                  <div className="fw-semibold text-success small">
                                    $
                                  </div>
                                </div>
                                <div className="col-6">
                                  <small className="text-muted">
                                    Entradas:
                                  </small>
                                  <div className="fw-medium small">
                                    {cupon.limite ?? 0}
                                  </div>
                                </div>
                              </div>

                              <div className="d-flex justify-content-between align-items-center">
                                <span
                                  className="badge bg-success me-2"
                                  style={{ fontSize: "0.7rem" }}
                                >
                                  {cupon.status}
                                </span>
                                <small className="text-muted">{}</small>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>

            <div
              className="d-none d-md-flex flex-column flex-sm-row justify-content-between align-items-center my-4"
              style={{
                marginLeft: "120px",
                marginRight: "120px",
              }}
            >
              <div className="mb-2 mb-sm-0">
                <small className="text-muted">
                  Mostrando{" "}
                  <span className="fw-medium">CUPONES {data?.total}</span>
                </small>
              </div>

              <div>
                {data.links.map((link) => {
                  if (link.label == "&laquo; Previous") {
                    return (
                      <label
                        className={`btn btn-outline-dark me-1 ${
                          link.active ? "active" : ""
                        } ${link.url ? "" : "disabled"}`}
                      >
                        <i class="bi bi-chevron-left"></i>
                        ANTERIOR
                      </label>
                    );
                  }
                  if (link.label == "Next &raquo;") {
                    return (
                      <label
                        className={`btn btn-outline-dark ${
                          link.active ? "active" : ""
                        } ${link.url ? "" : "disabled"}`}
                      >
                        SIGUIENTE
                        <i class="bi bi-chevron-right"></i>
                      </label>
                    );
                  }
                  return (
                    <label
                      className={`btn btn-outline-dark me-1 ${
                        link.active ? "active" : ""
                      }`}
                    >
                      {link.label}
                    </label>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cupones;
